import { render } from "./ProductLabel.vue?vue&type=template&id=06dba918&scoped=true"
import script from "./ProductLabel.vue?vue&type=script&lang=js"
export * from "./ProductLabel.vue?vue&type=script&lang=js"

import "./ProductLabel.vue?vue&type=style&index=0&id=06dba918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dba918"]])

export default __exports__